export const makeSelectActionSpinner = (state: AppState) => state.globalReducer.actionSpinner;
export const makeSelectFetchSpinner = (state: AppState) => state.globalReducer.fetchSpinner;
export const makeSelectFetchDetailsSpinner = (state: AppState) =>
  state.globalReducer.fetchDetailsSpinner;
